import React from 'react';
import PropTypes from 'prop-types';
import { fromJS } from 'immutable';

import { getIcon } from '../utils';

export const StepLink = ({ commercialProducts, strings, handleGetRoute }) => {
  const onClickHandler = code => {
    handleGetRoute({ route: `/quotations/${code}` });
  };

  let commProdList = [];

  commercialProducts.forEach(commProd => (commProdList = [...commProdList, ...commProd.get('products')]));

  return commProdList?.length ? (
    <div className="step stepLink">
      <h1 className="md-title md-cell md-cell--12 subtitle">{strings['title.quotation.link']}</h1>
      {commProdList.map((commProd, index) => (
        <div
          role="button"
          tabIndex={index}
          // eslint-disable-next-line react/no-array-index-key
          key={`${commProd.get('id')}-${index}`}
          onClick={() => onClickHandler(commProd.get('code'))}
          onKeyPress={() => onClickHandler(commProd.get('code'))}
        >
          <div className="survey-label">{commProd.get('name')}</div>
          <div className="survey-icon">{getIcon(commProd.toJS())}</div>
        </div>
      ))}
    </div>
  ) : (
    <></>
  );
};

StepLink.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  commercialProducts: PropTypes.object,
  strings: PropTypes.objectOf(PropTypes.string),
  handleGetRoute: PropTypes.func,
};

StepLink.defaultProps = {
  commercialProducts: fromJS({}),
  strings: {},
  handleGetRoute: params => console.log('handleGetRoute ::', params),
};
